<template>
    <div>
        <el-tag><i class="el-icon-edit-outline">待办事项</i></el-tag>
        <el-row :gutter="20">
            <el-col :span="5">
                <el-card class="card-s" style="box-shadow: 0 0px 0px #ccc;border: none">
                    <div class="card-content">
                        <a href="#" style="font-size: 20px;color: cornflowerblue">{{DaiShenFang}}</a>
                        <div>
                            待审方
                        </div>
                    </div>
                </el-card>
            </el-col>
            <el-col :span="5">
                <el-card class="card-s" style="box-shadow: 0 0px 0px #ccc;border: none">
                    <div class="card-content">
                        <a href="#" style="font-size: 20px;color: cornflowerblue">{{DaiFaHuo}}</a>
                        <div>
                            待发货
                        </div>
                    </div>
                </el-card>
            </el-col>
            <el-col :span="5">
                <el-card class="card-s" style="box-shadow: 0 0px 0px #ccc;border: none">
                    <div class="card-content">
                        <a href="#" style="font-size: 20px;color: cornflowerblue">{{DaiShouHuo}}</a>
                        <div>
                            待收货
                        </div>
                    </div>
                </el-card>
            </el-col>
            <el-col :span="5">
                <el-card class="card-s" style="box-shadow: 0 0px 0px #ccc;border: none">
                    <div class="card-content">
                        <a href="#" style="font-size: 20px;color: cornflowerblue">{{DaiShenDoctor}}</a>
                        <div>
                            待审核医生
                        </div>
                    </div>
                </el-card>
            </el-col>
        </el-row>
        <el-tag><i class="el-icon-tickets">今日简报</i></el-tag>
        <el-row>
            <el-col :span="7">
                <el-card class="card-s bc-color1">
                    <div class="card-content">
                        <div>
                            订单数量
                        </div>
                        <a href="#" style="font-size: 20px">{{DayOrder}}</a>
                        <div>
                            昨日：{{YesterdayOrderCount}}
                        </div>
                    </div>
                </el-card>
            </el-col>
            <el-col :span="7">
                <el-card class="card-s bc-color2">
                    <div class="card-content">
                        <div>
                            订单金额
                        </div>
                        <a href="#" style="font-size: 20px">{{orderTotalPrice/100}}</a>
                        <div>
                            昨日：{{yesterdayOrderTotalPrice/100}}
                        </div>
                    </div>
                </el-card>
            </el-col>
            <el-col :span="7">
                <el-card class="card-s bc-color3">
                    <div class="card-content">
                        <div>
                            新增医生
                        </div>
                        <a href="#" style="font-size: 20px">{{addDoctor}}</a>
                        <div>
                            昨日：{{yesterdayAddDoctor}}
                        </div>
                    </div>
                </el-card>
            </el-col>
        </el-row>

        <el-tag>
            <div class="item_title">
                <i class="el-icon-finished">营业数据趋势图</i>
                <!--<div class="choose-box">
                    <input type="radio" id="radio7" name="choose" value="7" checked/>
                    <label for="radio7">近7天</label>&nbsp;
                    <input type="radio" id="radio15" name="choose" value="15"/>
                    <label for="radio15">近15天</label>&nbsp;
                    <input type="radio" id="radio30" name="choose" value="30"/>
                    <label for="radio30">近30天</label>
                </div>-->
                <el-radio-group v-model="radio1" size="small" @change="queryOrderDetails()">
                    <el-radio label="1">近7天</el-radio>
                    <el-radio label="2">近15天</el-radio>
                    <el-radio label="3">近30天</el-radio>
                </el-radio-group>
            </div>
        </el-tag>
        <el-row justify="space-around">
            <el-col :span="12">
                <div id="orderAmount" :style="{width: '600px',height:'400px'}"></div>
            </el-col>
            <el-col :span="12">
                <div id="orderCount" :style="{width: '600px',height:'400px'}"></div>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="12">
                <el-tag><i class="el-icon-finished">昨日药品类别占比</i></el-tag>
                <div id="drugRatio" :style="{width: '750px',height:'450px'}"></div>
            </el-col>
            <el-col :span="12">
                <el-tag><i class="el-icon-finished">营业简报</i></el-tag>

                <el-table
                        :data="tableData"
                        stripe
                        style="width: 70%">
                    <el-table-column
                            prop="date"
                            label="日期"
                            width="150">
                    </el-table-column>
                    <el-table-column
                            prop="orderCount"
                            label="订单数量"
                            width="150">
                    </el-table-column>
                    <el-table-column
                            prop="medicineTotalPrice"
                            label="处方金额"
                            width="150">
                    </el-table-column>
                    <el-table-column
                            prop="addDoctor"
                            label="新增医生"
                            width="150">
                    </el-table-column>
                </el-table>

            </el-col>
        </el-row>
    </div>
</template>

<script>

    import {format} from 'date-fns'

    export default {
        data() {
            return {
                authorization: localStorage.getItem('authorization'),
                DaiShenFang: '',//待审方
                DaiFaHuo: '',//待发货
                DaiShouHuo: '',//待收货
                DaiShenDoctor: '',//待审核医生
                DayOrder: '',//今日订单数
                YesterdayOrderCount: '',//昨日订单数
                orderTotalPrice: '',//处方金额
                yesterdayOrderTotalPrice: '',//昨日处方金额
                addDoctor: '',//今日新增医生
                yesterdayAddDoctor: '',//昨日新增医生
                weekOrderCount: '',//本周订单数量
                lastWeekOrderCount: '',//上周订单数量
                monthOrderCount: '',//本月订单数量
                lastMonthOrderCount: '',//上月订单数量
                quarterOrderCount: '',//本季度订单数量
                lastQuarterOrderCount: '',//上季度订单数量
                weekOrderTotalPrice: '',//本周处方金额
                lastWeekOrderTotalPrice: '',//上周处方金额
                monthOrderTotalPrice: '',//本月处方金额
                lastMonthOrderTotalPrice: '',//上月处方金额
                quarterOrderTotalPrice: '',//本季度处方金额
                lastQuarterOrderTotalPrice: '',//上季度处方金额
                weekAddDoctor: '',//本周新增医生
                lastWeekAddDoctor: '',//上周新增医生
                monthAddDoctor: '',//本月新增医生
                lastMonthAddDoctor: '',//上月新增医生
                quarterAddDoctor: '',//本季度新增医生
                lastQuarterAddDoctor: '',//上季度新增医生
                radio1: '1',
                tableData: [{
                    date: '昨日',
                    orderCount: '',
                    medicineTotalPrice: '',
                    addDoctor: ''
                }, {
                    date: '本周',
                    orderCount: '',
                    medicineTotalPrice: '',
                    addDoctor: ''
                }, {
                    date: '上周',
                    orderCount: '',
                    medicineTotalPrice: '',
                    addDoctor: ''
                }, {
                    date: '本月',
                    orderCount: '',
                    medicineTotalPrice: '',
                    addDoctor: ''
                }, {
                    date: '上月',
                    orderCount: '',
                    medicineTotalPrice: '',
                    addDoctor: ''
                }, {
                    date: '本季度',
                    orderCount: '',
                    medicineTotalPrice: '',
                    addDoctor: ''
                }, {
                    date: '上季度',
                    orderCount: '',
                    medicineTotalPrice: '',
                    addDoctor: ''
                }],

                // 示例数据需要从接口获取
                orderAmountData: {
                    xAxis: [],
                    data: [],
                },
                orderCountData: {
                    xAxis: [],
                    data: [],
                },
                drugRatioData: {
                    opinion: [],
                    opinionData: [

                    ]
                },
            }
        },
        mounted() {
            // 1，从接口拿数据 2 赋值 3 draw...
            this.queryOrderDetails();

            this.initMedicinesProportion();
            this.notCheckRecipe();
            this.queryDoctorCount();
            //this.queryInviteDoctor();//医生邀请的医生递归
        },
        methods: {
            orderDataInit(orderData) {
                let xDate = []
                let yAmount = []
                let yCount = []
                orderData.forEach((item, index, array) => {
                        let d = orderData[index]
                        let date = format(new Date(d.orderDate), 'yyyy-MM-dd')
                        xDate[index] = date
                        yAmount[index] = d.orderMoney
                        yCount[index] = d.orderCount
                    }
                )
                this.orderCountData.xAxis = xDate
                this.orderAmountData.xAxis = xDate
                this.orderAmountData.data = yAmount
                this.orderCountData.data = yCount
            },
            ratioDataInit(kindData) {
                this.drugRatioData.opinionData = kindData;
                let keyList = [];
                kindData.forEach((item, index, array) => {
                    keyList[index] = item.name
                })
                this.drugRatioData.opinion = keyList
            },
            drawRatio() {
                let drugRatioChart = this.$echarts.init(document.getElementById("drugRatio"))
                drugRatioChart.setOption({
                    tooltip: {
                        trigger: 'item',
                    },
                    legend: {
                        orient: 'vertical',
                        x: 'left',
                        data: this.drugRatioData.opinion,
                    },
                    series: [
                        {
                            name: '性别',
                            type: 'pie',
                            avoidLabelOverlap: false,
                            // label:{
                            //     normal:{
                            //         show:false,
                            //         position:'center'
                            //     },
                            //     emphasis:{
                            //         show:true,
                            //         textStyle:{
                            //             fontSize:'30'
                            //         }
                            //     }
                            // }
                            data: this.drugRatioData.opinionData,
                        }
                    ]
                })
            },
            drawOrderAmount() {
                let orderAmountChart = this.$echarts.init(document.getElementById("orderAmount"))
                let orderCountChart = this.$echarts.init(document.getElementById("orderCount"))
                orderAmountChart.setOption({
                    //title: {text: "营业数据趋势图"},
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            label: {
                                backgroundColor: '#6a7985'
                            }
                        }
                    },
                    xAxis: {
                        name: '付款日期',
                        // data: this.orderAmountData.xAxis,
                        data: this.orderAmountData.xAxis,
                        type: 'category',
                        boundaryGap: false,
                        axisLabel: {
                            interval: 0,
                            rotate: 40
                        }
                    },
                    yAxis: {
                        name: '订单数量',
                        type: 'value',
                    },
                    series: [
                        {
                            name: '数量',
                            data: this.orderAmountData.data,
                            type: 'line',
                            // 设置小圆点消失
                            // 注意：设置symbol: 'none'以后，拐点不存在了，设置拐点上显示数值无效
                            symbol: 'none',
                            // 设置折线弧度，取值：0-1之间
                            smooth: 0,
                        },
                    ]
                })
                orderCountChart.setOption({
                    //title: {text: "营业数据趋势图"},
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            label: {
                                backgroundColor: '#6a7985'
                            }
                        }
                    },
                    xAxis: {
                        name: '付款日期',
                        data: this.orderCountData.xAxis,
                        type: 'category',
                        boundaryGap: false,
                        axisLabel: {
                            interval: 0,
                            rotate: 40
                        }
                    },
                    yAxis: {
                        name: '订单金额',
                        type: 'value'
                    },
                    series: [
                        {

                            name: '金额',
                            data: this.orderCountData.data,
                            type: 'line',
                            // 设置小圆点消失
                            // 注意：设置symbol: 'none'以后，拐点不存在了，设置拐点上显示数值无效
                            symbol: 'none',
                            // 设置折线弧度，取值：0-1之间
                            smooth: 0,
                        },
                    ]


                })

            },

            //营业指数
            // initQueryOrder(state) {
            //     this.axios.get('api-b/10041/100158/' + state, {
            //         headers:{
            //             Authorization: this.authorization
            //         }
            //     }).then(res => {
            //         if (res.data.code === 10000) {
            //
            //         } else {
            //             this.$message.error(res.data.message)
            //         }
            //     })
            // }
            initMedicinesProportion() {
                this.axios.get('api-s/10061/100602', {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then(res => {
                    this.ratioDataInit(res.data.data)
                    this.drawRatio()
                })
            },
            //数据查询
            notCheckRecipe() {
                this.loading = true
                this.axios.get('api-s/10061/100604', {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then(res => {
                    // alert(JSON.stringify(res.data.data))
                    this.DaiShenFang = res.data.data.pendingOrder;
                    this.DaiFaHuo = res.data.data.sendOrder - res.data.data.pendingOrder;
                    this.DaiShouHuo = res.data.data.takeOrder;
                    this.DayOrder = res.data.data.orderCount;
                    this.orderTotalPrice = res.data.data.orderTotalPrice;
                    this.YesterdayOrderCount = res.data.data.yesterdayOrderCount;
                    this.tableData[0].orderCount = res.data.data.yesterdayOrderCount
                    this.yesterdayOrderTotalPrice = res.data.data.yesterdayOrderTotalPrice;
                    this.tableData[0].medicineTotalPrice = res.data.data.yesterdayOrderTotalPrice/100
                    this.weekOrderCount = res.data.data.weekOrderCount;
                    this.tableData[1].orderCount = res.data.data.weekOrderCount

                    this.lastWeekOrderCount = res.data.data.lastWeekOrderCount;
                    this.tableData[2].orderCount = res.data.data.lastWeekOrderCount

                    this.monthOrderCount = res.data.data.monthOrderCount;
                    this.tableData[3].orderCount = res.data.data.monthOrderCount

                    this.lastMonthOrderCount = res.data.data.lastMonthOrderCount;
                    this.tableData[4].orderCount = res.data.data.lastMonthOrderCount

                    this.quarterOrderCount = res.data.data.quarterOrderCount;
                    this.tableData[5].orderCount = res.data.data.quarterOrderCount

                    this.lastQuarterOrderCount = res.data.data.lastQuarterOrderCount;
                    this.tableData[6].orderCount = res.data.data.lastQuarterOrderCount

                    this.weekOrderTotalPrice = res.data.data.weekOrderTotalPrice;
                    this.tableData[1].medicineTotalPrice = res.data.data.weekOrderTotalPrice/100

                    this.lastWeekOrderTotalPrice = res.data.data.lastWeekOrderTotalPrice;
                    this.tableData[2].medicineTotalPrice = res.data.data.lastWeekOrderTotalPrice/100

                    this.monthOrderTotalPrice = res.data.data.monthOrderTotalPrice;
                    this.tableData[3].medicineTotalPrice = res.data.data.monthOrderTotalPrice/100

                    this.lastMonthOrderTotalPrice = res.data.data.lastMonthOrderTotalPrice;
                    this.tableData[4].medicineTotalPrice = res.data.data.lastMonthOrderTotalPrice/100

                    this.quarterOrderTotalPrice = res.data.data.quarterOrderTotalPrice;
                    this.tableData[5].medicineTotalPrice = res.data.data.quarterOrderTotalPrice/100

                    this.lastQuarterOrderTotalPrice = res.data.data.lastQuarterOrderTotalPrice;
                    this.tableData[6].medicineTotalPrice = res.data.data.lastQuarterOrderTotalPrice/100


                })
            },
            queryDoctorCount() {
                this.axios.get('api-b/10061/100605', {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then(res => {
                    //alert(JSON.stringify(res.data.data.exemineDorder))
                    this.DaiShenDoctor = res.data.data.exemineDorder;
                    this.addDoctor = res.data.data.addDoctor;
                    this.yesterdayAddDoctor = res.data.data.yesterdayAddDoctor;
                    this.tableData[0].addDoctor = res.data.data.yesterdayAddDoctor//昨日新增医生

                    this.weekAddDoctor = res.data.data.weekAddDoctor;//本周新增医生
                    this.tableData[1].addDoctor = res.data.data.weekAddDoctor//本周新增医生

                    this.lastWeekAddDoctor = res.data.data.lastWeekAddDoctor;//上周新增医生
                    this.tableData[2].addDoctor = res.data.data.lastWeekAddDoctor//上周新增医生

                    this.monthAddDoctor = res.data.data.monthAddDoctor;//本月新增医生
                    this.tableData[3].addDoctor = res.data.data.monthAddDoctor//本月新增医生

                    this.lastMonthAddDoctor = res.data.data.lastMonthAddDoctor;//上月新增医生
                    this.tableData[4].addDoctor = res.data.data.lastMonthAddDoctor//上月新增医生

                    this.quarterAddDoctor = res.data.data.quarterAddDoctor;//本季度新增医生
                    this.tableData[5].addDoctor = res.data.data.quarterAddDoctor//本季度新增医生

                    this.lastQuarterAddDoctor = res.data.data.lastQuarterAddDoctor;//上季度新增医生
                    this.tableData[6].addDoctor = res.data.data.lastQuarterAddDoctor//上季度新增医生

                })
            },
            queryOrderDetails() {
                if (this.radio1 === "1") {
                    this.queryServenDay();
                } else if (this.radio1 === "2") {
                    this.queryFifteenDay();
                } else if (this.radio1 === "3") {
                    this.queryThirtyDay();
                }
            },
            queryServenDay() {
                this.axios.get('api-s/10061/100601', {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then(res => {
                    this.orderDataInit(res.data.data)
                    this.drawOrderAmount();
                })
            },
            queryFifteenDay() {
                this.axios.get('api-s/10061/100606', {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then(res => {
                    this.orderDataInit(res.data.data)
                    this.drawOrderAmount();
                })
            },
            queryThirtyDay() {
                this.axios.get('api-s/10061/100607', {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then(res => {
                    this.orderDataInit(res.data.data)
                    this.drawOrderAmount();
                })
            },
            /*queryInviteDoctor() {
                this.axios.get('api-b/10061/100608',{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    //alert(JSON.stringify(res.data.data))
                    console.log(res.data.data)
                })
            },*/
        },
    }
</script>

<style>

    .card-content {
        text-align: center;
        margin-top: 5px;
    }

    .card-s {
        height: 100px;
        padding: 0
    }


    el-row {
        margin-bottom: 20px;
        display: flex;
        flex-wrap: wrap
    }

    .bc-color1 {
        background: #f39906;
    }

    .bc-color2 {
        background: rgba(232, 12, 115, 0.54);
    }

    .bc-color3 {
        background: rgba(130, 25, 226, 0.71);
    }

</style>